// This file is auto-generated by Lovable. Do not modify it.

import { createLovableAuth } from "@lovable.dev/cloud-auth-js";
import { supabase } from "../supabase/client";
// Detect if we're on a custom domain (not Lovable infrastructure)
const isCustomDomain = 
  typeof window !== 'undefined' &&
  !window.location.hostname.includes('lovable.app') &&
  !window.location.hostname.includes('lovableproject.com') &&
  window.location.hostname !== 'localhost';

// Configure OAuth broker URL:
// - Custom domains: Use Lovable's centralized OAuth broker (project_id passed via extraParams)
// - Lovable domains: Use the default relative path (infrastructure knows the project)
const lovableAuth = createLovableAuth({
  oauthBrokerUrl: isCustomDomain 
    ? 'https://oauth.lovable.app/initiate'
    : '/~oauth/initiate',
});

type SignInOptions = {
  redirect_uri?: string;
  extraParams?: Record<string, string>;
};

export const lovable = {
  auth: {
    signInWithOAuth: async (provider: "google" | "apple", opts?: SignInOptions) => {
      const result = await lovableAuth.signInWithOAuth(provider, {
        redirect_uri: opts?.redirect_uri,
        extraParams: {
          ...opts?.extraParams,
        },
      });

      if (result.redirected) {
        return result;
      }

      if (result.error) {
        return result;
      }

      try {
        await supabase.auth.setSession(result.tokens);
      } catch (e) {
        return { error: e instanceof Error ? e : new Error(String(e)) };
      }
      return result;
    },
  },
};
